<template>
  <!-- 还款记录 -->
  <div class="paymentHistory">
    <md-popup v-model="isPopupShow" position="right" :mask-closable="true" @beforeHide="closePop">
      <div class="detailBox">
        <!-- 标题 -->
        <div class="titleBox">
          <md-icon name="wrong" size="sm" @click="closePop"></md-icon>
          <span class="title">还款记录</span>
          <!-- <span class="printer" @click="orderPrint">打印</span> -->
        </div>
        <!--总览  -->
        <div class="totalBox" v-if="list.length>0">
          <div>
            <div>还款单数</div>
            <div>{{total.count_distinct}}单</div>
          </div>
          <div>
            <div>还款金额</div>
            <div>{{total.repayment_total*1}}元</div>
          </div>
          <div>
            <div>还款优惠</div>
            <div>{{total.discount_amount_total*1}}元</div>
          </div>
        </div>
        <div class="history_list">
          <!-- 列表 -->
          <md-scroll-view
            ref="scrollView"
            :auto-reflow="true"
            :manual-init="true"
            :bouncing="false"
            :scrolling-x="false"
            @end-reached="$_onEndReached"
          >
            <!---->
            <div class="detailList" v-for="(item,i) in list" :key="i">
              <div v-if="list.length>0">
                <div>
                  <div class="out_box">
                    <div class="item1">
                      <div>{{item.pay_time| toTime}}</div>
                      <div>还款时间</div>
                      <!-- <div>
                      <span>
                        <span v-for="(goods_item,goods_index) in item.goods" :key="goods_index">
                          <span v-if="goods_index >0">,</span>
                          {{goods_item.name}}
                        </span>
                      </span>
                      </div>-->
                    </div>
                    <div class="item2">
                      <div>
                        <span class="money_symbol">￥</span>
                        {{item.repayment_amount*1 || 0}}
                      </div>
                      <div>还款金额</div>
                    </div>
                    <div class="item2">
                      <div>
                        <span class="money_symbol">￥</span>
                        {{item.discount_amount*1}}
                      </div>
                      <div>还款优惠</div>
                    </div>
                    <div class="item3">
                      <div>{{item.user_realname}}</div>
                      <div>收银员</div>
                    </div>
                    <div class="item4">
                      <div v-if="item.isUp==false" @click="changeStatus(i)">
                        <span>展开</span>
                        <md-icon
                          name="arrow-down"
                          size="xs"
                          style="color:#31b158;margin-top:0.04rem"
                        ></md-icon>
                      </div>

                      <div v-if="item.isUp==true" @click="changeStatus(i)">
                        <span>收起</span>
                        <md-icon name="arrow-up" size="xs" style="color:#31b158;margin-top:0.04rem"></md-icon>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 里面一层 -->
                <div class="inner_box" v-if="item.isUp">
                  <div
                    class="item"
                    @click="lookDetail(goods_item.order_sn)"
                    v-for="(goods_item,goods_index) in item.annal_list"
                    :key="goods_index"
                  >
                    <div class="item4">
                      <div>{{item.pay_time| toTime}}</div>
                      <div>开票员：{{item.user_realname}}</div>
                    </div>

                    <div class="item3">
                      <div>
                        <span class="money_symbol">￥</span>
                        {{goods_item.repayment*1}}
                      </div>
                      <div>还款</div>
                    </div>
                    <div class="item2">
                      <div>
                        <span
                          v-for="(goods_list_item,goods_list_i) in  goods_item.order_goods_list"
                          :key="goods_list_i"
                        >
                          <span v-if="goods_list_i >0">,</span>
                          {{goods_list_item.name}}
                        </span>
                      </div>
                      <div>采购货品</div>
                    </div>
                    <div class="item1">
                      <span v-if="goods_item.orderCredit.status==1">还清</span>
                      <span
                        v-if="goods_item.orderCredit.status==0"
                        style="background:rgba(255, 0, 0, 0.3);color:rgb(255, 0, 0)"
                      >赊欠</span>
                    </div>

                    <div class="item5">查看</div>
                  </div>
                </div>
              </div>
            </div>
            <div style="color:#999;font-size:0.24rem;text-align:center;line-height:1rem" v-if="list.length==0">暂无数据</div>
            <md-scroll-view-more
              :finished-text="list.length>0?'全部已加载':'暂无数据'"
              slot="more"
              :is-finished="isFinished"
            ></md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>
    </md-popup>
    <!-- 订单详情 -->
    <orderDetail
      :pop_show="isShowDetail"
      :orderId="orderId"
      @cancel="isShowDetail=false;orderId = ''"
    />
  </div>
</template>
<script>
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import {
  buyer_detail_repayment,
  buyer_history_total,
} from "@/api/work/buyer.js";
import orderDetail from "../order/orderDetail";
export default {
  name: "paymentHistory",
  components: {
    orderDetail,
  },
  data() {
    return {
      isPopupShow: false,
      isFinished: false,
      listQuery: {
        buyer_id: "",
        page: 1,
        pageSize: 10,
      },
      list: [],
      total: {
        count_distinct: 0, //还款单数
        repayment_total: 0, //还款金额
        discount_amount_total: 0, //还款优惠金额
      },
      orderId: "",
      isShowDetail: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 打开弹窗
    showPop(id) {
      this.listQuery.buyer_id = id;
      this.getPayHistory();
      this.getPayTotal();
      this.$refs.scrollView.init();
      this.isPopupShow = true;
    },
    //关闭弹窗
    closePop() {
      this.isPopupShow = false;
      this.order_sn = "";
      this.list = [];
      this.resetData();
      this.$emit("cancel");
      this.$emit("finish");
    },
    // 重置数据
    resetData() {
      this.listQuery = {
        buyer_id: "",
        page: 1,
        pageSize: 15,
      };
    },

    //获取列表
    getPayHistory() {
      buyer_detail_repayment(this.listQuery).then((res) => {
        if (res.code == 200) {
          if (this.listQuery.page == 1) this.list = [];
          this.list = this.list.concat(res.data.list);
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].isUp = false;
          }
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.listQuery.page++;
            this.$nextTick(() => {
              this.$refs.scrollView.finishLoadMore();
            });
          }
        }
      });
    },
    //获取总览
    getPayTotal() {
      buyer_history_total({ buyer_id: this.listQuery.buyer_id }).then((res) => {
        if (res.code == 200) {
          this.total.count_distinct = res.data.count_distinct || 0;
          this.total.repayment_total = res.data.repayment_total || 0;
          this.total.discount_amount_total =
            res.data.discount_amount_total || 0;
        }
      });
    },

    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getPayHistory();
    },

    //小票打印
    // orderPrint() {
    //   if (this.printLoading) {
    //     this.printLoading = false;
    //     order_print({ order_sn: "" })
    //       .then((res) => {
    //         this.printLoading = true;
    //         if (res.code == 200) {
    //           this.$toast.success(res.message);
    //         }
    //       })
    //       .catch((err) => {
    //         this.printLoading = true;
    //       });
    //   }
    // },
    //展开
    changeStatus(index) {
      this.list = [...this.list];
      this.list[index].isUp = !this.list[index].isUp;
    },
    //查看详情
    lookDetail(goodsId) {
      if (goodsId) {
        this.isPopupShow = true;
        this.orderId = goodsId;
        this.isShowDetail = true;
      } else {
        //补录订单
        this.$toast.info("补录订单,不可查看详情");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.paymentHistory {
  .detailBox {
    width: 8.14rem;
    height: calc(100% - 0.54rem);
    background: #fff;
    overflow: hidden;
    .titleBox {
      width: 8.14rem;
      height: 0.8rem;
      padding: 0.18rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 0.01rem solid #e5e5e5;
      z-index: 1000;
      background: #fff;
      .title {
        color: #404040;
        font-size: 0.28rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      .printer {
        color: #31b158;
        font-size: 0.2rem;
        margin-top: 0.06rem;
      }
    }
    .totalBox {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0.2rem 0.12rem;
      box-shadow: 0 0.04rem 0.04rem 0.02rem #e1e1e1;
      & > div {
        width: 33%;
        text-align: center;
      }
    }
    // .z_empty {
    //   height: 10px;
    //   background: #f5f5f5;
    // }
    .history_list {
      height: calc(100% - 1.84rem);
      .detailList {
        > div:nth-of-type(1) {
          width: 100%;
          padding: 0 0.2rem;
          border-bottom: 0.01rem solid #e5e5e5;
          .out_box {
            display: flex;
            padding: 0.2rem 0rem;
            height: 1rem;
            justify-content: space-between;
            .item1 {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 2rem;
              margin-right: 0.2rem;
              font-size: 0.16rem;
              div:nth-of-type(1) {
                width: 2rem;
                color: #999;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
              div:nth-of-type(2) {
                width: 2rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                color: #999;
              }
            }
            .item2 {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              margin-right: 0.2rem;
              width: 1.8rem;
              > div:nth-of-type(1) {
                width: 1.8rem;
                color: #404040;
                font-size: 0.24rem;
                font-weight: bold;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
              > div:nth-of-type(2) {
                width: 1.8rem;
                color: #999999;
                font-size: 0.16rem;
              }
            }
            .item3 {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 1rem;
              div:nth-of-type(1) {
                width: 1rem;
                color: #404040;
                font-size: 0.22rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
              div:nth-of-type(2) {
                width: 1rem;
                color: #999999;
                font-size: 0.16rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .item4 {
              display: flex;
              align-items: center;
              width: 1rem;
              padding-left: 0.1rem;
              > div:nth-of-type(1) {
                width: 1rem;
                color: #31b158;
                font-size: 0.2rem;
                display: flex;
                align-items: center;
              }
            }
          }
        }

        .inner_box {
          padding: 0 0.3rem;
          .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.16rem;
            padding: 0.06rem 0;
            height: 0.8rem;
            border-bottom: 0.01rem solid #e5e5e5;
            color: #999;
            > div {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100%;
            }
            .item1 {
              width: 0.8rem;
              span {
                padding: 0rem 0.1rem;
                font-size: 0.18rem;
                border-radius: 0.12rem;
                background: rgba(49, 177, 88, 0.3);
                color: rgb(49, 177, 88);
              }
            }
            .item2 {
              width: 1.2rem;
              text-align: left;
              > div:nth-of-type(1) {
                color: #999;
                font-size: 0.22rem;
                width: 1.2rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
              > div:nth-of-type(2) {
                width: 100%;
              }
            }
            .item3 {
              width: 1.4rem;
              text-align: left;
              > div:nth-of-type(1) {
                color: #404040;
                font-size: 0.22rem;
                width: 100%;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
              > div:nth-of-type(2) {
                width: 100%;
              }
            }
            .item4 {
              width: 1.58rem;
              text-align: left;
              > div {
                width: 100%;
              }
            }

            .item5 {
              color: #31b158;
              text-align: left;
            }
          }
        }
      }
    }
    .listEmpty {
      text-align: center;
      color: #999;
      margin-top: 0.4rem;
    }
  }
  .money_symbol {
    font-size: 0.16rem;
  }
}
</style>
<style lang="less">
.paymentHistory .md-popup-mask {
  top: 0.54rem;
  left: 0.7rem;
}
.paymentHistory .md-popup.right .md-popup-box {
  background: #fff;
  margin-top: 0.54rem;
}
.paymentHistory .md-popup.right .md-popup-box {
  overflow-y: scroll;
}
</style>